export default __webpack_public_path__ + "locales/uk-UA/EmptyTrashDialog.json?hash=0e7c20e9344262570932fbf55eef838e";